/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { Modal, Button, Transition, Grid } from "semantic-ui-react";
import styles from "./ConfirmationDialog.module.css";
import cStyles from "../Components.module.css";
import { Ico } from "../Icon/Icon";
import { useTranslation } from "react-i18next";

interface ConfirmationDialogProps {
  title: string;
  message: string;
  okTitle?: string;
  onOk: any;
  cancelTitle?: string;
  onCancel?: any;
  optionalContent?: any;
  optionalContentProp?: any;
  closeOnDimmerClick?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  message,
  okTitle,
  onOk,
  cancelTitle,
  onCancel,
  optionalContent,
  optionalContentProp,
  closeOnDimmerClick,
}) => {
  const { t } = useTranslation("common");

  return (
    <Transition transitionOnMount={true} animation="fade" duration="300">
      <Modal
        closeOnDimmerClick={closeOnDimmerClick === true}
        size="small"
        open
        onClose={onCancel || onOk}
      >
        <Grid stackable columns={3} padded style={{ padding: "15px" }}>
          <Grid.Row>
            <Grid.Column width={14}>
              <span className={cStyles.title}>{title}</span>
            </Grid.Column>

            <Grid.Column width={2} floated="right">
              <div
                className={cStyles.closeButton}
                onClick={() => (onCancel ? onCancel() : onOk())}
              >
                <Ico name="cancel" style={{ color: "#ffffff", margin: 0 }} />
              </div>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row className={styles.formRow}>
            <Grid.Column width={16} verticalAlign="middle">
              <label className={styles.fieldLabel}>{message}</label>
            </Grid.Column>
          </Grid.Row>

          {optionalContent && (
            <Grid.Row className={styles.formRow}>
              <Grid.Column width={16} verticalAlign="middle">
                {optionalContent(optionalContentProp)}
              </Grid.Column>
            </Grid.Row>
          )}

          <Grid.Row>
            {onCancel && (
              <Grid.Column width={8}>
                <Button
                  id="cancelButton"
                  secondary
                  className={cStyles.buttonSecond}
                  onClick={() => {
                    onCancel();
                  }}
                >
                  <Ico name="cancel" style={{ marginRight: "10px" }} />
                  {cancelTitle || t("cancel")}
                </Button>
              </Grid.Column>
            )}

            <Grid.Column width={8} floated="right" textAlign="right">
              <Button
                id="okButton"
                primary
                className={cStyles.buttonPrime}
                onClick={() => {
                  onOk();
                }}
              >
                <Ico name="check" style={{ marginRight: "10px" }} />
                {okTitle || t("ok")}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal>
    </Transition>
  );
};

export default ConfirmationDialog;
